<template>
    <div class="Row">
      <div class="RowTitle mr-2">{{title}}</div>
      <slot>
      </slot>
    </div>
</template>

<script>
  export default {
    name: 'Row',
    data: function () {
        return { };
    },

    props: ["title"],
  }
</script>

<style>
.Row {
    min-height: 30px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
}
.RowTitle {
    font-family: Helvetica, Arial, sans-serif;
    font-size: 18px;
    color: #CCC;
    cursor: default;
    display: block;
    vertical-align: middle;
    min-width: 140px;
    width: 140px;
    -webkit-user-select: none; /* Safari */        
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard */
}
</style>
